import { render, staticRenderFns } from "./check.vue?vue&type=template&id=538afdb9&scoped=true"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"
import style0 from "./check.vue?vue&type=style&index=0&id=538afdb9&prod&lang=scss&scoped=true"
import style1 from "./check.vue?vue&type=style&index=1&id=538afdb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538afdb9",
  null
  
)

export default component.exports